// extracted by mini-css-extract-plugin
module.exports = {"covid":"CovidTestResultPage_covid__2glUZ"};